import { Config, vservice } from '@niknevis/vue-modules'
import { TicketStoreRequestModel } from '@/modules/ticket/models/ticket-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { PanelTicketRoute } from '@/modules/ticket/routes/panel-ticket.route'
import { WriterTicketRoute } from '@/modules/ticket/routes/writer-ticket.route'
import { PanelType } from '@/modules/shared/interfaces/panel-type'
import { TicketAnswerRequestModel } from '@/modules/ticket-answer/models/ticket-answer-request.model'
import Dialog from 'quasar/src/plugins/Dialog.js';
import WarningConfirm from '@/modules/common/dialog/components/shared/WarningConfirm.vue'

@vservice()
export class TicketService {
  constructor(
    private readonly panelRoutes: PanelTicketRoute,
    private readonly writerRoutes: WriterTicketRoute,
  ) {
  }

  get route() {
    const userType: PanelType = Config.get('userType')

    switch (userType) {
      case PanelType.WRITER:
        return this.writerRoutes
      default:
        return this.panelRoutes
    }
  }

  storeTicket(data: TicketStoreRequestModel) {
    const formData = new FormData()
    Object.keys(data).forEach((key) => {
      if (key === 'file') return
      formData.append(key, data[key])
    })

    if (data.files && data.files.length > 0) {
      data.files.forEach(file => {
        if (file instanceof File) {
          formData.append('files[]', file)
        }
      })
    }

    return Inertia.post(
      this.route.store(),
      formData
    )
  }

  newAnswerTicket(ticketId: number, data: TicketAnswerRequestModel) {
    return Inertia.post(
      this.route.newAnswer(ticketId),
      data
    )
  }

  openTicket(ticketId: number) {
    return Inertia.put(
      this.route.openTicket(ticketId)
    )
  }

  closeTicket(ticketId: number) {
    return Inertia.put(
      this.route.closeTicket(ticketId)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: WarningConfirm,
        message: 'شما در حال بستن تیکت میباشید. بعد از تایید، امکان ارسال پیام وجود نخواهد داشت. آیا تایید میکنید؟',
        submitText: 'بستن تیکت',
        title: 'بستن تیکت'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }
}
